
import { Challenge } from '@/types/challenges';

export const ONBOARDING_CHALLENGE: Challenge = {
  key: 'onboarding',
  titleKey: 'challenges:onboarding.title',
  subtitleKey: 'challenges:onboarding.subtitle',
  tasks: [
    {
      key: 'createEntry',
      titleKey: 'challenges:onboarding.tasks.createEntry.title',
      descriptionKey: 'challenges:onboarding.tasks.createEntry.description',
      target: 1,
      actionKey: 'challenges:onboarding.actions.goToTimeline',
      actionLink: '/timeline'
    },
    {
      key: 'inviteFriends',
      titleKey: 'challenges:onboarding.tasks.inviteFriends.title',
      descriptionKey: 'challenges:onboarding.tasks.inviteFriends.description',
      target: 2,
      actionKey: 'challenges:onboarding.actions.inviteFriends',
      actionLink: '/friends'
    },
    {
      key: 'receiveFriendEntries',
      titleKey: 'challenges:onboarding.tasks.receiveFriendEntries.title',
      descriptionKey: 'challenges:onboarding.tasks.receiveFriendEntries.description',
      target: 3
    },
    {
      key: 'addToFriendTimeline',
      titleKey: 'challenges:onboarding.tasks.addToFriendTimeline.title',
      descriptionKey: 'challenges:onboarding.tasks.addToFriendTimeline.description',
      target: 2,
      actionKey: 'challenges:onboarding.actions.findFriends',
      actionLink: '/friends'
    }
  ]
};

export const AVAILABLE_CHALLENGES = [ONBOARDING_CHALLENGE];
